<template>
  <tab-layout>
    <cart :cartMembers="cartMembers" :nominate="nominate" @cartChanged="cartChanged()" slot="tabContent" class="tab-pane col-12 col-xl-9 px-0 show active" id="cart" role="tabpanel" aria-label="Cart" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import horseRegisterCart from './CartDetails'

export default {
  name: 'HorseRegisterCart',
  props: ['nominate'],
  components: {
    'tab-layout': tabLayout,
    cart: horseRegisterCart
  },
  data() {
    return {
      cartMembers: this.$store.state.cartMembers
    }
  },
  methods: {
    cartChanged() {
      this.cartMembers = this.$store.state.cartMembers
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Horses/Cart/Cart.vue